import React, { useEffect } from "react";
import IHome from "../interfaces/IHome";
import { createModal } from "../utils/CreateModal";
import { useWindowDimensions } from "./WindowDimensionsProvider";
import Affiliate from "../utils/Affiliate";
import useUser from "../stores/useUser";
import { RemoteClose, modal } from "./AsyncModal";
import PropertyMessage from "./PropertyMessage";
import History from '../utils/BrowserHistory';
import Button from "./MaterialUi/Button";
import { removeVarFromLocationUrl } from "../utils/getVarsFromUrl";

export interface IPropertyMessageButtonProps {
  className?: string;
  propertyId: string;
  needsPremium: boolean;
  typeOfMarketing: IHome['marketingType'];
  buttonWidth?: string
}

const customCss = {
    width: "100%",
    fontWeight: 400,
    letterSpacing: "0.1px",
    fontSize: "0.875rem",
    padding: "16px 24px"
} as const

const browserAffiliate = Affiliate.getBrowserAffiliate();

// 2 buttons are rendered in the page, only one should open the modal
let modalIsAlreadyOpened = false;

const PropertyMessageButton: React.FC<IPropertyMessageButtonProps> = ({ className = '', propertyId, needsPremium, typeOfMarketing, buttonWidth }) => {

    const [user] = useUser();
    const { width } = useWindowDimensions();

    const openMessageModal = () => {

        if (modalIsAlreadyOpened) {
            return;
        }

        modalIsAlreadyOpened = true;
        const remoteCloseModal = new RemoteClose();
        modal(<PropertyMessage id={propertyId} remoteClose={remoteCloseModal} needsPremium={needsPremium} marketingType={typeOfMarketing} affiliatePartnerId={undefined} />,
            { maxWidth: 'md', title: 'Anbieter kontaktieren', remoteClose: remoteCloseModal, disableBackdropClick: true })
            .then(() => {
                console.debug('modal closed');
            })
            .catch(() => {
                console.debug('modal closed (x)');
            })
            .finally(() => {
                modalIsAlreadyOpened = false;
                removeVarFromLocationUrl('modal');
            });
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('modal') === 'message') {
            openMessageModal();
        }

        const unlisten = History.listen(({ location }) => {
            const params = new URLSearchParams(window.location.search);
            if (params.get('modal') === 'message') {
                console.debug('on history change: open modal');
                openMessageModal();
            }
        });
        return unlisten;
    }, []);

    const handleClick = () => {
        if ((browserAffiliate == "vr-win" && !user.affiliateName) || user.affiliateName == "vr-win") {
            createModal.createSetAffiliateStepper(propertyId, needsPremium, typeOfMarketing);
        } else {
            // createModal.createPropertyMessage(propertyId, needsPremium, typeOfMarketing);
            openMessageModal();
        }
    }

    if (buttonWidth) {
    // @ts-ignore
        customCss.width = buttonWidth;
    } else {
    // @ts-ignore
        customCss.width = '100%';
    }

    if (width <= 1024) {
    // @ts-ignore
    //customCss.height = "56px";
    } else {
    // @ts-ignore
    //customCss.height = "72px";

    }

    return <Button
        sx={customCss}
        onClick={handleClick}
    >Anbieter kontaktieren</Button>
};

export default React.memo(PropertyMessageButton);
